export default "__VITE_ASSET__BRDrKcQD__"